module.exports = require("@swa-ui/design-tokens");